<template>
  <div class="quotes">
    <!-- <v-dialog v-model="dialog" max-width="600" persistent>
      <v-card>
        <v-card-text>
          <div class="d-flex justify-space-between pt-2">
            <h3 class="black--text">Quotes</h3>
            <v-icon @click="$emit('close')">mdi-close</v-icon>
          </div>
          <v-divider class="black--text"></v-divider>

          <div v-for="i in 2" :key="i" class="quotes">
            <v-hover v-slot="{ hover }">
              <v-card
                :elevation="hover ? 12 : 0"
                class="py-1 px-2 cursor-pointer"
              >
                <div
                  class="d-flex flex-wrap align-center justify-space-between"
                >
                  <div class="mb-1 mb-sm-0">
                    <h6 class="primary--text pb-0 mb-0">
                      <strong>ABC Dealer Quote 1</strong>
                    </h6>
                    <div>
                      <strong class="black--text">Total Price: </strong>
                      <span class="black--text">$300</span>
                    </div>
                    <div>
                      <strong class="black--text">Est Delivery Date: </strong>
                      <span class="black--text">11/12/23</span>
                    </div>
                  </div>
                  <div class="text-left text-md-right">
                    <strong>Sent: </strong>
                    <span>11-04-23 12:44 PM</span>
                    <br />

                    <v-chip
                      v-if="i === 1"
                      color="green"
                      class="white--text mr-1"
                      label
                      small
                      >Latest</v-chip
                    >
                    <v-btn
                      small
                      depressed
                      color="primary"
                      @click="acceptModal = true"
                      >Accept Bid</v-btn
                    >
                  </div>
                </div>
                <div class="grey--text">
                  <strong>Notes:</strong>
                  <span class="pl-1">this is the latest with change x</span>
                </div>
              </v-card>
            </v-hover>
            <v-divider class="ma-1"></v-divider>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog> -->

    <v-dialog v-model="dialog" fullscreen>
      <v-card>
        <v-card-text>
          <div class="d-flex align-center justify-space-between pt-2">
            <div v-if="lastBid" class="d-flex align-center flex-wrap">
              <h4 class="black--text">Quote #: {{ quote.bids.length }}</h4>
              <div class="ml-3">
                <strong class="black--text"
                  >Dealer: {{ quote.dealer.company || "N/A" }}</strong
                >
              </div>
              <div class="ml-3">
                <strong class="black--text"
                  >Price: {{ lastBid.bid_amount || "N/A" }}</strong
                >
              </div>
              <div class="ml-3">
                <strong class="black--text"
                  >Bid Date:
                  {{ new Date(lastBid.sent_on).toLocaleDateString() }}</strong
                >
              </div>
              <div class="ml-3">
                <strong class="black--text"
                  >Est Delivery Date: {{ lastBid.bid_delivery_time }}</strong
                >
              </div>
            </div>
            <v-icon @click="$emit('close')">mdi-close</v-icon>
          </div>
          <v-divider class="black--text mt-1"></v-divider>
          <div>
            <v-row v-if="lastBid" no-gutters>
              <!-- <v-col cols="6" sm="6" md="3" class="pb-1">
                <strong class="black--text"
                  >Dealer: <br />
                  {{ quote.dealer.company || "N/A" }}</strong
                >
              </v-col>
              <v-col cols="6" sm="6" md="3" class="pb-1">
                <strong class="black--text"
                  >Price: <br />
                  ${{ lastBid.bid_amount }}</strong
                >
              </v-col>
              <v-col cols="6" sm="6" md="3" class="pb-1">
                <strong class="black--text"
                  >Bid Date: <br />
                  {{ new Date(lastBid.sent_on).toLocaleDateString() }}</strong
                >
              </v-col>
              <v-col cols="6" sm="6" md="3" class="pb-1">
                <strong class="black--text"
                  >Est Delivery Date: <br />
                  {{ lastBid.bid_delivery_time }}</strong
                >
              </v-col>  -->
              <v-col cols="12" sm="8" md="9">
                <strong class="black--text">Comments:</strong>
                <p class="mb-1">{{ lastBid.comment || "N/A" }}</p>
              </v-col>
              <v-col cols="12" sm="4" md="3" class="text-right">
                <v-btn
                  v-if="
                    quote.status === 'bided' && schedule.status !== 'awarded'
                  "
                  depressed
                  color="primary"
                  @click="acceptModal = true"
                  ><v-icon class="mr-1" size="18"
                    >mdi-check-circle-outline</v-icon
                  >
                  Accept</v-btn
                >
              </v-col>
            </v-row>

            <div class="pdf-viewer">
              <!-- <template v-if="isLoading">
                <div class="text-center">
                  <strong>Loading Quote...</strong>
                </div>
              </template> -->
              <template>
                <iframe
                  :src="lastBid.bid_pdf"
                  width="100%"
                  height="600"
                  frameborder="0"
                  style="border: 0px 0px; width: 100%;"
                ></iframe>
                <!-- <VuePdfEmbed
                  ref="pdfRef"
                  source="https://teosite-dev-space.sfo3.digitaloceanspaces.com/RFQ_FILE_9505c31a-9cbe-4e2d-95f7-715fed0f6204_0a44870a-06e1-4f2a-8cb1-2852e2f15a37.pdf"
                  @rendered="handleDocumentRender"
                /> -->
              </template>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="acceptModal" max-width="450">
      <v-card>
        <v-card-text>
          <div class="d-flex justify-space-between pt-2">
            <h3 class="black--text">Bid #{{ quote.bids.length }}</h3>
            <v-icon @click="acceptModal = false">mdi-close</v-icon>
          </div>
          <v-divider class="black--text"></v-divider>
          <h3 class="text-center black--text">Accept this Bid?</h3>
          <p class="black--text">
            Once accepted XYZ will be notified, and bidding will be closed to
            all other dealers.
          </p>

          <div class="mt-4 text-center">
            <v-row no-gutters class="text-left">
              <v-col cols="6" class="pa-1">
                <h5 class="black--text">Quote:</h5>
                <span>#{{ quote.bids.length }}</span>
              </v-col>
              <v-col cols="6" class="pa-1">
                <h5 class="black--text">Dealer:</h5>
                <span>{{ quote.dealer.company || "N/A" }}</span>
              </v-col>
              <v-col cols="6" class="pa-1">
                <h5 class="black--text">Price:</h5>
                <span>${{ lastBid.bid_amount }}</span>
              </v-col>
              <v-col cols="6" class="pa-1">
                <h5 class="black--text">Bid Date:</h5>
                <span>{{
                  new Date(lastBid.sent_on).toLocaleDateString()
                }}</span>
              </v-col>
            </v-row>

            <v-btn
              depressed
              color="primary"
              class="mt-3"
              :loading="acceptLoading"
              @click="acceptBid"
              ><v-icon class="mr-1" size="18">mdi-check-circle-outline</v-icon>
              Accept Bid</v-btn
            >
            <v-btn
              depressed
              color="red"
              outlined
              class="ml-1 mt-3"
              :disabled="acceptLoading"
              @click="acceptModal = false"
            >
              Cancel
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { PATH_WINDOWS } from "@/data/pathData";
// import VuePdfEmbed from "vue-pdf-embed";

export default {
  // components: {
  //   VuePdfEmbed: () => import("vue-pdf-embed/dist/vue2-pdf-embed")
  // },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    quote: {
      type: Object,
      default: null
    },
    schedule: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      acceptModal: false,
      acceptLoading: false,
      lastBid: null,
      isLoading: true,
      page: null,
      pageCount: 1,
      showAllPages: true
    };
  },
  created() {
    this.lastBid = null;
    if (this.quote && this.quote.bids && this.quote.bids.length > 0) {
      this.getLastBid(this.quote.bids);
    }
  },
  watch: {
    quote(val) {
      if (val && val.bids && val.bids.length > 0) {
        this.getLastBid(val.bids);
      }
    },
    showAllPages() {
      this.page = this.showAllPages ? null : 1;
    }
  },
  methods: {
    goToSchedule() {
      this.$router.push(PATH_WINDOWS);
    },
    handleDocumentRender() {
      console.log("Rendered");
      this.isLoading = false;
      this.pageCount = this.$refs.pdfRef.pageCount;
    },
    getLastBid(bids) {
      if (Array.isArray(bids) && bids.length > 0) {
        this.lastBid = bids.at(-1);
      }
    },

    acceptBid() {
      const payload = {
        id: this.quote.id
      };

      this.acceptLoading = true;

      this.$store
        .dispatch("rfq/acceptBid", payload)
        .then(() => {
          this.acceptModal = false;
          this.$emit("refresh");
        })
        .finally(() => {
          this.acceptLoading = false;
        });
    }
  }
};
</script>

<style scoped>
.pdf-viewer {
  width: 100%;
  overflow-y: auto;
}

#thumbnail-bar {
  display: none !important;
}
</style>
